module.exports = __webpack_public_path__ + "img/facebook.422e7665.svg";